function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_614_1824)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.46777 21.8633H21.5234C23.4219 21.8633 24.4062 20.8877 24.4062 19.0156V8.31055C24.4062 6.43848 23.4219 5.46289 21.5234 5.46289H6.46777C4.56934 5.46289 3.58496 6.42969 3.58496 8.31055V19.0156C3.58496 20.8877 4.56934 21.8633 6.46777 21.8633ZM11.3984 17.2578C10.9238 17.2578 10.7041 16.9941 10.7041 16.6162V10.7012C10.7041 10.3232 10.9238 10.0596 11.3984 10.0596H12.3477C12.8135 10.0596 13.0332 10.3232 13.0332 10.7012V16.6162C13.0332 16.9941 12.8135 17.2578 12.3477 17.2578H11.3984ZM15.6699 17.2578C15.2041 17.2578 14.9756 16.9941 14.9756 16.6162V10.7012C14.9756 10.3232 15.2041 10.0596 15.6699 10.0596H16.6191C17.0762 10.0596 17.3047 10.3232 17.3047 10.7012V16.6162C17.3047 16.9941 17.0762 17.2578 16.6191 17.2578H15.6699Z",
  fill: "currentColor"
}));

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.a985390f.svg";
export { ForwardRef as ReactComponent };